import { render, staticRenderFns } from "./gateWayConfig.vue?vue&type=template&id=5aab0ad1&"
import script from "./gateWayConfig.vue?vue&type=script&lang=js&"
export * from "./gateWayConfig.vue?vue&type=script&lang=js&"
import style0 from "./gateWayConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aab0ad1')) {
      api.createRecord('5aab0ad1', component.options)
    } else {
      api.reload('5aab0ad1', component.options)
    }
    module.hot.accept("./gateWayConfig.vue?vue&type=template&id=5aab0ad1&", function () {
      api.rerender('5aab0ad1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/gateWayConfig.vue"
export default component.exports